module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp1_5010.d388985e.png";